import {Component, Input} from '@angular/core';
import {mtestOptionsActions} from '@shared/constants/mtest.constants';
import {IdName} from '@core/src/public-api';
import {DocumentOptionActionService} from '@shared/services/document-option-action.service';
import {MedicalTestViewerData} from "@models/medical-test.model";

@Component({
  selector: 'si-mtest-medical-test-download-icons',
  templateUrl: './mtest-medical-test-download-icons.component.html',
  styleUrls: ['./mtest-medical-test-download-icons.component.scss']
})
export class MtestMedicalTestDownloadIconsComponent {
  @Input() requestId: number;
  @Input() iconStyleClass: string;
  @Input() openTop: boolean;
  @Input() images: IdName[];
  optionDownloadValues: IdName[];
  optionImageValues: IdName[];
  optionShareValues: IdName[];
  mtestOptionsActions = mtestOptionsActions;
  shareDialogData: MedicalTestViewerData;
  shareDialogOption: IdName;
  displayShareDialog = false;
  private _actions: string[];

  constructor(
    private documentOptionActionService: DocumentOptionActionService
  ) {
  }

  get actions(): string[] {
    return this._actions;
  }

  @Input()
  set actions(val) {
    this._actions = val;
    this.initReportOptionValues();
  }

  initReportOptionValues(): void {
    this.optionDownloadValues = this.documentOptionActionService.initReportOptionValuesMtest(this.actions);
    this.optionImageValues = this.documentOptionActionService.initImageOptionValuesMtest(this.actions, this.images);
    this.optionShareValues = this.documentOptionActionService.initShareOptionValuesMtest(this.actions, this.images);
  }

  onSelectDownloadOption(option: IdName): void {
    this.documentOptionActionService.onSelectOptionMtest(this.requestId, option);
  }

  async onSelectShareOption(option: IdName): Promise<void> {
    const documentResult = await this.documentOptionActionService.getShareMtestResults(this.requestId, option);
    this.openShareDialog(option, documentResult);
  }

  openShareDialog(option: IdName, data: MedicalTestViewerData): void {
    this.shareDialogOption = option;
    this.shareDialogData = data;
    this.displayShareDialog = true;
  }
}
